export default "__VITE_ASSET__62tSevoy__"